<template>
  <schedule-container-form
    :edit="editSchedule"
    :entityType="entityType"
    :entityId="entityId"
    :feeName="feeName"
    @added="backToList"
    @updated="backToList"
    @cancel="backToList"
  />
</template>

<script>
import { mapState } from 'vuex';

import { wizardStepMixin } from '@/mixins/wizardStep';
import ScheduleContainerForm from '@/components/forms/ScheduleContainerForm';
import { TableName } from '@/enums/tableName.enum';

// @vuese
// Formularz do edycji/dodawania harmonogramów
// @group Schedule
export default {
  mixins: [wizardStepMixin('fee', 1)],
  props: {
    // Czy formularz edycji
    edit: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    ScheduleContainerForm
  },
  computed: {
    entityType() {
      return TableName.Fee;
    },
    entityId() {
      return this.$route.params.feeId.toString();
    },
    ...mapState({
      feeEntityType: state => state.fee.entityType,
      count: state => state.schedule.count,
      feeName: state => state.fee.data.name
    }),
    editSchedule() {
      return Boolean(this.count && this.edit);
    }
  },

  methods: {
    // @vuese
    // Powrót do listy składek
    backToList() {
      this.$router.push({ name: `${this.feeEntityType}Fees` });
    }
  }
};
</script>